import api from './api';
import { CurrencyRate } from '../context/CurrencyContext';

/**
 * Service for handling currency-related API requests
 */
const currencyService = {
  /**
   * Fetch currency exchange rates from the API
   * @returns Promise with currency rates
   */
  getCurrencyRates: async (): Promise<{ currencies: CurrencyRate[] }> => {
    try {
      const response = await api.get('/currencies');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch currency rates:', error);
      // Fallback with default rates
      return {
        currencies: [
          { code: 'USD', rate: 1 },
          { code: 'ILS', rate: 3.63 },
          { code: 'EUR', rate: 0.92 }
        ]
      };
    }
  }
};

export default currencyService; 